<script lang="ts">
    import cep from 'cep-promise'
    import { onMount, createEventDispatcher } from 'svelte'
    import type { GatewayPublicInfo } from '../../../modules/paymentsApi/gateways/gateway.entity'
    import { AssignNewCardDto } from '../../../modules/paymentsApi/customer-cards/dto/assign-new-card.dto'

    export let gateway: GatewayPublicInfo
    export let card: AssignNewCardDto = new AssignNewCardDto()

    const dispatch = createEventDispatcher()

    let step = 0
    onMount(async () => {
        await loadPage()
    })

    async function loadPage() {
        step = 1
    }

    function setBrand(brand: string) {
        card.card.brand = brand
    }

    async function searchAddress(force: boolean) {
        if (!force && card.customer.addressStreet) {
            console.log('no-cep', card.customer.addressStreet)
            return
        }
        const cleanCEP = card.customer.addressCEP?.replace('-', '') || ''
        if (cleanCEP.length !== 8) {
            window.error('CEP inválido.')
            return
        }
        try {
            const res = await cep(cleanCEP)
            card.customer.addressStreet = res.street || ''
            card.customer.addressState = res.state || ''
            card.customer.addressCity = res.city || ''
            card.customer.addressNeighborhood = res.neighborhood || ''
        } catch (error) {
            card.customer.addressStreet = ''
            card.customer.addressState = ''
            card.customer.addressCity = ''
            card.customer.addressNeighborhood = ''
        }
    }

    async function evaluateCustomer() {
        // clean infos
        if (card.customer.document) {
            card.customer.document = window.api.utils.utils.sanitizeDocument(card.customer.document)
        }
        // validation
        if (card.customer.name?.length < 5 || !card.customer.name?.includes(' ')) {
            window.error('Informe o nome completo')
            return
        }
        if (gateway.requiredCustomerInfo.includes('email')) {
            if (!card.customer.email || !card.customer.email?.includes('@')) {
                window.error('Informe um e-mail')
                return
            }
        }
        if (gateway.requiredCustomerInfo.includes('phone')) {
            if (!card.customer.phone || card.customer.phone?.length < 10) {
                window.error('Informe um telefone com DDD')
                return
            }
        }
        if (card.customer.document?.length < 11) {
            window.error('Documento inválido')
            return
        }
        if (!window.api.utils.utils.validateCNPJ(card.customer.document) && !window.api.utils.utils.validateCPF(card.customer.document)) {
            window.error('Documento inválido')
            return
        }
        if (card.customer.addressCEP) {
            card.customer.addressCEP = card.customer.addressCEP.replace('-', '')
        }
        if (card.customer.addressCEP?.length !== 8) {
            window.error('Informe um CEP válido')
            return
        }
        if (!card.customer.addressNumber) {
            window.error('Informe o número do imóvel.\nCaso não possua um número informe 0 ou sn')
            return
        }
        console.log('card', card)
        await searchAddress(false)
        step = 2 //address
    }

    function evaluateAddress() {
        if (card.customer.addressCEP) {
            card.customer.addressCEP = card.customer.addressCEP.replace('-', '')
        }
        if (card.customer.addressCEP?.length !== 8) {
            window.error('Informe um CEP válido')
            return
        }
        if (card.customer.addressStreet?.trim().length === 0) {
            window.error('Informe o endereço')
            return
        }
        if (card.customer.addressNumber?.trim() === '') {
            window.error('Informe o número do imóvel.\nCaso não possua um número informe 0 ou sn')
            return
        }
        if (card.customer.addressNeighborhood?.trim().length === 0) {
            window.error('Informe o bairro')
            return
        }
        if (card.customer.addressCity?.trim().length === 0) {
            window.error('Informe a cidade')
            return
        }
        if (card.customer.addressState?.trim().length !== 2) {
            window.error('Informe o estado')
            return
        }
        step = 3
        console.log('card', card)
    }

    async function evaluateCard() {
        if (card.card.number) card.card.number = card.card.number.replaceAll('-', '').replaceAll(' ', '')
        if (!window.api.utils.utils.validateCreditCard(card.card?.number?.toString(), card.card?.brand)) {
            window.error('Cartão inválido')
            return
        }
        if (!card.card.brand) {
            window.error('Selecione a bandeira do cartão clicando na imagem')
            return
        }
        if (card.card.name?.length < 3 || !card.card.name?.includes(' ')) {
            window.error('Informe o nome impresso no cartão')
            return
        }
        if (!card.card.expirationMonth || !card.card.expirationYear) {
            window.error('Informe a data de vencimento do cartão')
            return
        }
        let date = new Date(parseInt(card.card.expirationYear), parseInt(card.card.expirationMonth) - 1, 31)
        if (date.getTime() - new Date().getTime() < 0) {
            window.error('O cartão informado está vencido')
            return
        }
        if (card.card.securityCode?.length < 3 || card.card.securityCode?.length > 5) {
            window.error('Informe um código de segurança válido')
            return
        }
        card.card.expirationMonth = card.card.expirationMonth.toString()
        card.card.expirationYear = card.card.expirationYear.toString()
        console.log('card', card)
        await dispatchSuccess()
    }

    async function dispatchSuccess() {
        dispatch('success')
    }
</script>

<div class="checkout">
    {#if step === 0}
        <div class="-box -loading">
            <div class="-line">Carregando...</div>
        </div>
    {/if}
    {#if step === 1}
        <div class="-box -box-customer">
            <div class="spacer" />
            <div class="-line -padding">
                <label for="" class="-label">Nome completo do PROPRIETÁRIO do cartão</label>
                <input type="text" bind:value={card.customer.name} />
            </div>
            <div class="-line -padding">
                <label for="" class="-label">CPF do PROPRIETÁRIO do cartão</label>
                <input type="text" inputmode="numeric" bind:value={card.customer.document} />
            </div>
            {#if gateway.requiredCustomerInfo.includes('email')}
                <div class="-line -padding">
                    <label for="" class="-label">E-mail</label>
                    <input type="text" inputmode="email" bind:value={card.customer.email} />
                </div>
            {/if}
            {#if gateway.requiredCustomerInfo.includes('phone')}
                <div class="-line -padding">
                    <label for="" class="-label">Celular</label>
                    <input type="text" inputmode="tel" bind:value={card.customer.phone} />
                </div>
            {/if}
            <div class="-line -inline -padding">
                <div class="-mr-8">
                    <label for="">CEP de cobrança do cartão</label>
                    <input type="text" inputmode="numeric" class="-customer-zip" bind:value={card.customer.addressCEP} />
                </div>
                <div class="-line -grow">
                    <label for="">Nº imóvel</label>
                    <input type="text" class="-grow" bind:value={card.customer.addressNumber} />
                </div>
            </div>
            <div class="spacer" />
            <div class="-line -inline acts">
                <div class="fake-button" />
                <div class="-breadcrumb">
                    <span>◉</span>
                    <span>○</span>
                    <span>○</span>
                </div>
                <button on:click={evaluateCustomer}>Avançar</button>
            </div>
        </div>
    {/if}
    {#if step === 2}
        <div class="-box -box-address">
            <div class="spacer" />
            <div class="-line -padding">
                <label for="" class="-label">CEP</label>
                <input type="text" inputmode="numeric" class="-address-zip" bind:value={card.customer.addressCEP} />
            </div>
            <div class="-line -padding">
                <label for="" class="-label">Rua</label>
                <input type="text" bind:value={card.customer.addressStreet} />
            </div>
            <div class="-line -inline -padding">
                <div class="-mr-8">
                    <label for="">Número</label>
                    <input type="text" class="-address-number" bind:value={card.customer.addressNumber} />
                </div>
                <div class="-line -grow">
                    <label for="">Complemento</label>
                    <input type="text" class="-address-complement" bind:value={card.customer.addressComplement} />
                </div>
            </div>
            <div class="-line -padding">
                <label for="" class="-label">Bairro</label>
                <input type="text" class="-address-neighborhood" bind:value={card.customer.addressNeighborhood} />
            </div>
            <div class="-line -inline -padding">
                <div class="-line -grow -mr-8">
                    <label for="">Cidade</label>
                    <input type="text" class="-address-city" bind:value={card.customer.addressCity} />
                </div>
                <div>
                    <label for="">Estado</label>
                    <input type="text" class="-address-state" bind:value={card.customer.addressState} />
                </div>
            </div>
            <div class="spacer" />
            <div class="-line -inline acts">
                <button on:click={() => (step = 1)}>Voltar</button>
                <div class="-breadcrumb">
                    <span>○</span>
                    <span>◉</span>
                    <span>○</span>
                </div>
                <button on:click={evaluateAddress}>Avançar</button>
            </div>
        </div>
    {/if}
    {#if step === 3}
        <div class="-box -box-card">
            <div class="spacer" />
            <div class="-line -padding">
                <label for="-label">Nome no cartão</label>
                <input type="text" class="-name" bind:value={card.card.name} />
            </div>

            <div class="-line -padding">
                <div class="-line">
                    <label for="" class="-label">Número do cartão</label>
                    <input placeholder="xxxx xxxx xxxx xxxx" type="text" inputmode="numeric" class="-number" bind:value={card.card.number} />
                </div>
            </div>
            <div class="-line -flag -padding">
                <label for="">Selecione a bandeira</label>
                <div class="-inline">
                    {#each gateway.brands as brand}
                        <button on:click={() => setBrand(brand.brand)} class="button-flag" class:button-flag-active={brand.brand === card.card.brand}>
                            <img src="/img/card_{brand.brand}.png" alt="" />
                        </button>
                    {/each}
                </div>
            </div>
            <div class="-line -inline -padding">
                <div class="-month-year">
                    <label for="" class="-label">Validade</label>
                    <div class="-inline">
                        <select name="" id="" class="-month" bind:value={card.card.expirationMonth}>
                            <option value="" />
                            {#each Array(12) as month, i}
                                <option value={(i + 1).toString().padStart(2, '0')}>{(i + 1).toString().padStart(2, '0')}</option>
                            {/each}
                        </select>
                        <select name="" id="" class="-year" bind:value={card.card.expirationYear}>
                            <option value="" />
                            {#each Array(12) as month, i}
                                <option value={(i + new Date().getFullYear()).toString()}>{(i + new Date().getFullYear()).toString()}</option>
                            {/each}
                        </select>
                    </div>
                </div>

                <div>
                    <label for="" class="-label">Cód. Segurança</label>
                    <input type="text" inputmode="numeric" class="-sec" bind:value={card.card.securityCode} />
                </div>
            </div>
            <div class="spacer" />
            <div class="-line -inline acts">
                <button on:click={() => (step = 2)}>Voltar</button>
                <div class="-breadcrumb">
                    <span>○</span>
                    <span>○</span>
                    <span>◉</span>
                </div>

                <button on:click={evaluateCard}>Concluir</button>
            </div>
        </div>
    {/if}
</div>

<style>
</style>
